<template>
  <div style="height: 100%;">
    <page v-if="$route.path === '/link/culture'">
      <ZuiHeader />
      <SubPageTemplate page-title="文化遗产" dynamically-tab :pid="pid" type="article" :default-tab-id="defaultTabId" @article-click="articleClick"></SubPageTemplate>
      <ZuiFooter />
    </page>
    <router-view v-else></router-view>
  </div>
</template>
<script>
/** @format */

import SubPageTemplate from '~/components/template/SubPageTemplate.vue';
export default {
    components: {
        SubPageTemplate,
    },
    data() {
        return {
            pid: null,
            defaultTabId: '',
        };
    },
    created() {
        this.pid = this.$route.query.id || null;
        this.defaultTabId = this.$route.query.tabId || '';
        if (this.$route.path == '/link/culture') {
            let obj = {
                pid: this.pid,
                defaultTabId: this.defaultTabId,
            };
            sessionStorage.setItem('cultureParams', JSON.stringify(obj));
        }
    },
    watch: {
        $route(val, old) {
            console.log(val);
            if (this.$route.path == '/link/culture') {
                if ((!this.$route.query.id || !this.$route.query.tabId) && sessionStorage.getItem('cultureParams')) {
                    let obj = JSON.parse(sessionStorage.getItem('cultureParams'));
                    console.log(obj);
                    this.pid = obj.pid;
                    this.defaultTabId = obj.defaultTabId;
                }
            }
        },
    },
    methods: {
        articleClick(item) {
            this.$openNewWindow('/new/link/culture/info?id=' + item.id);
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/views/link/cultureHeritage.vue